<template>
  <div class="passenger-baggage">
    <label
      class="octobus__label is-size-7-touch has-text-grey has-text-weight-light"
      :for="`contact-info__baggage_${id}`"
    >
      {{$t('baggage.baggage')}}
    </label>
    <div class="octobus__select is-medium octobus__control is-fullwidth">
      <select
        :name="`contact-info__baggage_${id}`"
        :id="`contact-info__baggage_${id}`"
        :disabled="noBaggage"
        v-model="selectedBaggage"
        @change="setBaggage"
      >
        <option value="0">{{$t('baggage.no-baggage')}}</option>
        <option
          v-for="(baggage, index) of baggages"
          :key="index"
          :value="baggage"
        >{{baggage}}</option>
      </select>
    </div>
  </div>
</template>

<script>
const BAGGAGES = [1, 2, 3, 4];
const NO_BAGGAGE = ['0.00', '0', ''];

export default {
  name: 'Baggage',
  components: {
  },
  props: {
    priceBagg: {
      type: [Number, String],
    },
    id: {
      type: Number,
    },
    raceId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      baggages: BAGGAGES,
      selectedBaggage: NO_BAGGAGE.includes(this.priceBagg) ? '' : 0,
    };
  },
  computed: {
    noBaggage() {
      return NO_BAGGAGE.includes(this.priceBagg);
    },
  },
  methods: {
    setBaggage(event) {
      this.selectedBaggage = event.target.value;
      this.$emit('baggage:selected', this.selectedBaggage, this.raceId);
    },
  },
  mounted() {
    this.$emit('baggage:selected', this.selectedBaggage, this.raceId);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Passenger/Baggage.vue